import { Component, EventEmitter, Inject, Output, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BackOfficeService } from '../../../../../services/backoffice.service';
import { Subject, takeUntil } from 'rxjs';
import { AirTagVM } from '../../../../../models/orderModel';

@Component({
  selector: 'app-back-office24-orders-edit-vehicle-key-safe',
  standalone: false,
  templateUrl: './back-office24-orders-edit-vehicle-key-safe.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './back-office24-orders-edit-vehicle-key-safe.component.css'
})
export class BackOffice24OrdersEditVehicleKeySafeComponent {
  servicesForm: any;
  componentDestroyed$: Subject<boolean> = new Subject();
  @Output() saveChangesEvent = new EventEmitter<any>();
  editVehicleKeySafeForm: UntypedFormGroup;
  statusOptions: { value: string; name: string }[] = [
    { value: 'In', name: 'In' },
    { value: 'Out', name: 'Out' },
    { value: 'Returned', name: 'Returned' },
  ];
  isLoading: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      organizationId: string,
      orderId: string,
      airTagList: AirTagVM[],
      currentAirTag: AirTagVM,
      additionalServices: any[],
      // vehicleKeyStoreDetails: any,
    },
    private fb: UntypedFormBuilder,
    public backofficeService: BackOfficeService,
    public snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<BackOffice24OrdersEditVehicleKeySafeComponent>
  ) {
    this.initEmptyVehicleKeySafeForm();
  }

  ngOnInit(): void {
    this.initEditVehicleKeySafeForm();
  }

  tagAirTag(organizationId: string, orderId: string, airtagId: string, additionalServiceId: string) {
    this.isLoading = true;
    this.backofficeService.tagAirtag(organizationId, orderId, airtagId, additionalServiceId)
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe({
        next: () => {
          this.isLoading = false;
          this.dialogRef.close();
          this.saveChangesEvent.emit();
        },
        error: (err) => {
          this.isLoading = false;
          console.error(err);
          this.snackBar.open(err.message, 'Error', {
            verticalPosition: 'top',
            duration: 2000
          });
        }
      });
  }

  untagAirTag(organizationId: string, orderId: string, additionalServiceCompleted: boolean) {
    this.isLoading = true;
    this.backofficeService.untagAirtag(organizationId, orderId, additionalServiceCompleted)
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe({
        next: () => {
          this.isLoading = false;
          this.dialogRef.close();
          this.saveChangesEvent.emit();
        },
        error: (err) => {
          this.isLoading = false;
          console.error(err);
          this.snackBar.open(err.message, 'Error', {
            verticalPosition: 'top',
            duration: 2000
          });
        }
      });
  }


  initEmptyVehicleKeySafeForm() {
    this.editVehicleKeySafeForm = this.fb.group({
      // orderParkingId: [''],
      // safeStatus: [''],
      // safeNumber: [''],
      // safePickupDate: [''],
      // airTagStatus: [''],
      // airTagAttachDate: [''],
      airTagId: [{ value: '', disabled: this.data.currentAirTag }, Validators.required],
      selectedAdditionalService: [{ value: '', disabled: this.data.currentAirTag }, Validators.required],
    });

    if (this.data.currentAirTag) {
      this.editVehicleKeySafeForm.addControl(
        'additionalServiceCompleted',
        this.fb.control(false, [Validators.required])
      );
    }
  }

  initEditVehicleKeySafeForm() {
    this.editVehicleKeySafeForm = this.fb.group({
      // orderParkingId: [this.data.vehicleKeyStoreDetails.orderParkingId],
      // safeStatus: [this.data.vehicleKeyStoreDetails.safeStatus],
      // safeNumber: [this.data.vehicleKeyStoreDetails.safeNumber],
      // safePickupDate: [this.data.vehicleKeyStoreDetails.safePickupDate],
      // airTagStatus: [this.data.vehicleKeyStoreDetails.airTagStatus],
      // airTagAttachDate: [this.data.vehicleKeyStoreDetails.airTagAttachDate],
      airTagId: [{ value: this.data?.currentAirTag?.id || '', disabled: this.data.currentAirTag!==null && this.data.currentAirTag!==undefined }, Validators.required],
      selectedAdditionalService: [{ value: this.data?.currentAirTag?.orderAdditionServiceId || '', disabled: this.data.currentAirTag!==null && this.data.currentAirTag!==undefined }, Validators.required],
    })  ;

    if (this.data.currentAirTag) {
      this.editVehicleKeySafeForm.addControl(
        'additionalServiceCompleted',
        this.fb.control(false, [Validators.required])
      );
    }
  }

  submitForm() {
    if(this.editVehicleKeySafeForm.invalid) return;

    !this.data.currentAirTag ?
    this.tagAirTag(
      this.data.organizationId,
      this.data.orderId,
      this.editVehicleKeySafeForm.value.airTagId,
      this.editVehicleKeySafeForm.value.selectedAdditionalService
    ) :
    this.untagAirTag(
      this.data.organizationId,
      this.data.orderId,
      this.editVehicleKeySafeForm.value.additionalServiceCompleted
    );


    // this.backofficeService.updateAdditionalService(this.data.additionalService.id, this.editAdditionalServiceForm.value)
    //   .pipe(takeUntil(this.componentDestroyed$))
    //   .subscribe({
    //     next: () => {
    //       this.isLoading = false;
    //       this.dialogRef.close();
    //     },
    //     error: (err) => {
    //       this.isLoading = false;
    //       this.snackBar.open(err.message, 'Error', {
    //         verticalPosition: 'top',
    //         duration: 2000
    //       });
    //     }
    //   });
  }

  clearDate(event, value) {
    event.stopPropagation();
    value.setValue('', { emitEvent: false });
  }

  ngOnDestroy(): void {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }
}
